/**
 * CurrentPlanBanner - Exibe o plano atual do usuário
 * 
 * Extraído do App.js durante refatoração Fase 1
 * 
 * Dependências:
 * - useTranslation (traduções)
 * - useAuth (autenticação)
 * - axios (requisições API)
 */

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "../translations";
import { useAuth } from "../App";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CurrentPlanBanner = ({ onNavigateToPlans }) => {
  const [currentPlan, setCurrentPlan] = useState(null);
  const { user } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    fetchCurrentPlan();
  }, []);

  const fetchCurrentPlan = async () => {
    try {
      const response = await axios.get(`${API}/my-subscription`);
      setCurrentPlan(response.data);
    } catch (error) {
      console.error("Error fetching current plan:", error);
    }
  };

  if (!currentPlan) return null;

  const isProfessional = user?.user_type === 'professional';
  const planName = currentPlan.plan_name || t('currentPlan');
  const isFreePlan = currentPlan.is_free || currentPlan.plan_id?.includes('free') || currentPlan.plan_id?.includes('basic');

  // Para plano gratuito, mostrar apenas o banner de crescimento
  if (isFreePlan) {
    return (
      <div 
        onClick={() => onNavigateToPlans && onNavigateToPlans()}
        className="mb-6 p-4 rounded-xl border bg-gradient-to-r from-green-50 to-emerald-50 border-green-200 cursor-pointer hover:from-green-100 hover:to-emerald-100 transition-colors"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-3xl mr-3">🌱</span>
            <div>
              <p className="text-base font-semibold text-green-800">
                {t('growWithHeveaTalent')}
              </p>
              <p className="text-sm text-green-600">
                {t('discoverPlansAndResources')}
              </p>
            </div>
          </div>
          <span className="text-green-600 text-2xl">→</span>
        </div>
      </div>
    );
  }

  // Para planos pagos, mostrar o card normal com diamante
  return (
    <div className="mb-6 p-4 rounded-xl border bg-gradient-to-r from-yellow-50 to-orange-50 border-orange-200">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-orange-100">
          💎
        </div>
        <div>
          <h3 className="font-semibold text-orange-900">
            {planName}
          </h3>
          <p className="text-sm text-orange-700">
            {isProfessional 
              ? t('personalCalendarHistory')
              : t('advancedFeaturesUnlocked')
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default CurrentPlanBanner;
